import React from 'react';
import InstituteManagementPage from './InstituteManagementPage';

const KVKManagementPage = () => {
  return (
    <InstituteManagementPage 
      instituteType="kvk"
      instituteName="Krishi Vigyan Kendra (KVK), Malda"
    />
  );
};

export default KVKManagementPage;
